import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'nationality_4'

export const dataPointDefinition = {
  retracedId: 'nationality_4',
  name: 'Nationality #4',
  description:
    'Indicate the nationality representing the 4th greatest proportion of workers + supervisors in the facility (whether local or foreign)',
  meta: {
    slcpMeta: {
      key: 'fp-nat-5',
      number: 'FP-NAT-11',
      dataType: 'array',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: 'national',
      versionImported: '1.7.0',
      verificationTypeReq: 'Facility Profile',
      verificationSelectionOptList: 'verf-f-list',
      nonComOptionList: '',
      nonCompliance: '',
      humanShowHide: '[1],fp-nat-1,>3',
      machineShowHide: '[1],fp-nat-1,[>3]',
      completionCondition: 'any',
    },
  },
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'national',
      name: 'national',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['national'],
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'fp-nat-5', version: '1.7.0', provider: 'slcp'}],
  sortingId: 27820,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
